<mat-card appearance="outlined">
  <mat-card-content>
    <ng-container *ngIf="printNodeOrderWithItems">
      <ng-container *ngFor="let printNodeOrderItem of printNodeOrderWithItems.printNodeOrderItems">
        <app-print-node-order-item [printNodeOrderItem]="printNodeOrderItem"></app-print-node-order-item>
      </ng-container>
    </ng-container>
  </mat-card-content>
</mat-card>
